import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefreshCcw = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.99988 2V5.33333M1.99988 5.33333H5.33321M1.99988 5.33333L3.99988 3.52779C5.06139 2.57771 6.46317 2 7.99988 2C11.3136 2 13.9999 4.68629 13.9999 8C13.9999 11.3137 11.3136 14 7.99988 14C5.14443 14 2.75486 12.0053 2.14856 9.33333",
		stroke: "#363636",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRefreshCcw;
